import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./components/App"
import reportWebVitals from "./reportWebVitals"
import axios from "axios"
import runtimeEnv from "@mars/heroku-js-runtime-env"

const env = runtimeEnv()

axios.defaults.baseURL = env.REACT_APP_BACKEND_API_END_POINT

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
